/* eslint-disable no-unused-vars */
export enum LOGIN_TYPES {
  DEFAULT='DEFAULT',
  SSO='SSO'
}

export enum SOURCE_2FA_TYPES {
  UNKNOWN='UNKNOWN',
  NONE='NONE',
  EMAIL='EMAIL',
  TOTP='TOTP',
  /**
   * This value means that user has to setup TOTP before continuing
   */
  TOTP_LINK_DEVICE='TOTP-LINK_DEVICE'
}

export const SOURCE_2FA_TYPE_HEADER = 'X-MFA-TYPE';
